<navbar></navbar>

<ngx-spinner bdColor="rgba(0, 0, 0, .3)"
             size="medium"
             color="#fff"
             type="ball-scale-multiple">
  <p style="font-size: 20px; color: #fff">Carregando...</p>
</ngx-spinner>

<ng-container *ngIf="resultadoBusca">
  <div class="container">
    <div class="header">
      <div class="row">
        <h1>{{ resultadoBusca.nomAluno }}</h1>
        <br>

        <div class="col-md-3">
          <!--<p><b>Naturalidade:</b> {{ resultadoBusca.naturalidade }}</p>-->
          <p><b>CPF:</b> {{ resultadoBusca.cpfAluno}}</p>
          <p><b>Data de Nascimento:</b> {{ resultadoBusca.dtNascimento | date: 'dd/MM/yyyy':'+0000' }}</p>
        </div>

        <div class="col-md-3 offset-md-1 col-lg-3 second-block">
          <p><b>Naturalidade:</b> {{ resultadoBusca.naturalidade + ' - ' + resultadoBusca.ufNaturalidade }}</p>
          <p><b>RG:</b> {{ resultadoBusca.numIdentidade }}</p>
          <p><b>Sexo:</b> {{ resultadoBusca.indSexo | sexoEStatus }}</p>
        </div>

        <div class="col-md-6 col-lg-6 btn-status-container">
          <button>Status do histórico: <b>{{ resultadoBusca.indCancelado | sexoEStatus }}</b></button>
        </div>
      </div>
    </div>
  </div>

  <section class="section-pesquisa">
    <div class="container">
      <div class="row">
        <section class="col-md-8">
          <pdf-viewer [src]="pdf" class="pdf-content"
                      [render-text]="false"
                      [fit-to-page]="true"
                      [autoresize]="true"></pdf-viewer>
        </section>

        <section class="col-md-4">
          <div class="row pdf-buttons">
            <div class="col-sm-12 btn-downloads">
              <a [href]="downloadLinkXML" class="btn btn-orange" [attr.download]="nomeArquivoXML">Baixar XML</a>
              <a [href]="downloadLinkRVHE" class="btn btn-orange" [attr.download]="nomeArquivoRVHE">Baixar RVHE</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="erro">
  <div class="msg-erro-consulta">
    <alert [type]="'danger'" [dismissible]="true">Histórico não encontrado!</alert>
  </div>
</ng-container>
